module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Teaching practice guide result")]), _vm._v(" "), (_vm.$route.query.status == "noshow") ? _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("\n      It looks like your HAWO teaching practice guide didn't take place. "), _c('br'), _vm._v("Kindly contact your recruiter via email at\n      "), _c('a', {
    attrs: {
      "href": ("mailto:" + _vm.recruiter_email)
    }
  }, [_vm._v(_vm._s(_vm.recruiter_email))]), _vm._v(" to further assist you.\n    ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "failed") ? _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("We wish you all the best in your future endeavors.")]), _vm._v(" "), _vm._m(2)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Kind Regards, "), _c('br'), _vm._v(" HAWO Recruitment Team\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Thank you for your interest in joining the HAWO team. "), _c('br'), _vm._v("After thorough evaluation of your profile, we regret to inform you that your application was not selected for further consideration. While your qualifications are impressive, our selection process is highly competitive.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("The HAWO Recruitment Team")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-072246bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/tpg/result.vue
// module id = 817
// module chunks = 1